module.exports = __webpack_public_path__ + "static/media/part3.e2dc8ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part3.jpg
// module id = 805
// module chunks = 1